const TOOGLE_INPUT = "TOOGLE_INPUT";

export {
    TOOGLE_INPUT
}